
import Musicnote from "../../../assets/outline/Musicnote.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MusicnoteIcon({ className, dataTestid = "MusicnoteIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Musicnote data-testid={dataTestid} className={classes} {...rest} />
  );
}
